<section [ngClass]="isSticky === true ? 'sticky' : 'header'" *ngIf="productEntries?.length > 0">
  <div class="savings-total one sticky-total">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
        <div class="orderTitleSticky">
          Order Total:
          <span *ngIf="!updateTotal && headerLevelObj.length==0 else noPrice">
            <!-- {{ getTotalPriceCalc(stdCartDetails) | currency : 'USD' : 'symbol' : '1.2-2' }} -->
            <!-- {{standardCartDetails?.subTotal?.currencyIso}} -->

            {{subTotalVal | currency : 'USD' : 'symbol' :
            '1.2-2'}}
          </span><span *ngIf="headerLevelObj.length>0">$--</span>
          <!-- <ng-template #noPrice>
            {{ "addToCartItems.noprice" | cxTranslate }}
          </ng-template> -->
        </div>
        <p class="fw-bold m-0 p-0">Total Savings:&nbsp;<span class="greenfont"
            *ngIf="headerLevelObj.length==0">{{totalSavings | currency : 'USD' :
            'symbol' : '1.2-2'}}</span> <span *ngIf="headerLevelObj.length>0">$--</span></p>
      </div>
    </div>
    <div class="row m-0 p-0">
      <div class="col-lg-12 col-sm-12 col-md-12">
        <button *ngIf="!updateTotal" type="button" class="btn-primary" (click)="openmodal(content)"
          [disabled]="continueDisableCheck()" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
          <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
          Continue
        </button>
        <button class="btn-secondary" (click)="updateCart()">
          Edit Cart
        </button>
      </div>
    </div>
    <div class="row m-0 p-0">
      <div class="col-md-12 col-lg-12 col-sm-12">
        <div class="fw-bold m-0 p-0">By placing this order, you agree to the <a href="{{pdfUrl}}" target="_blank"
            class="fw-bold tncMobile">Terms &
            Conditions</a></div>
      </div>
    </div>
  </div>
</section>

<section class="preheader no-print">
  <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
    <section class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0 float-left emptyheader"></section>
    <section class="
        col-lg-3 col-md-3 col-sm-6 col-xs-12
        middle-row
        mt0
        text-right
        float-left
      ">
      <div class="totalQuantityDisplayBlock">
        <div class="quantityDisplay">
          {{ getQuantity(stdCartDetails) }} Units
        </div>
      </div>
      <a [routerLink]="['/Open-Catalogue/c/1']" target="" id="continueShoppingId" data-di-id="#continueShoppingId">
        <img src="../../assets/icons/{{baseSiteId}}/chevron-left.svg" alt="" class="chevron-left" />
        <!-- {{'addToCartItems.continueShopping'|cxTranslate}} -->
        Continue shopping
      </a>
    </section>
    <section class="
        col-lg-4 col-md-4 col-sm-6 col-xs-12
        text-right
        float-right
        p0
        header-links
      " *ngIf="productEntries?.length > 0">
      <section class="save-document save-document-container mb1 mt0">
        <ng-template #popSaveTitle>
          <!-- {{'addToCartItems.saveOrderTitle'|cxTranslate}} -->
          Name your order and save it for future orders
        </ng-template>
        <ng-template #popSaveContent>
          <input type="text" class="save-order saveOrderCheckout" required #name="ngModel" [(ngModel)]="saveCartName"
            (keypress)="omit_special_char($event)" maxlength="30" />
          <!-- <span *ngIf="name.errors?.required" class="common-error required">{{
            errorMsg
            }}</span> -->
          <span class="common-error required">{{ errorMsg }}</span>
          <button type="reset" class="popover-close btn btn-secondary popover-cancel-button saveOrderCheckoutBtn"
            (click)="toggleClose()">
            <!-- {{'addToCartItems.cancel'|cxTranslate}} -->
            Cancel
          </button>
          <button class="btn btn-primary popover-cancel-button saveOrderCheckoutBtSave ml-2" type="submit"
            data-di-id="di-id-3064f17d-e97cc628" (click)="saveOrder()">
            <!-- {{'addToCartItems.save'|cxTranslate}} -->
            Save
          </button>
        </ng-template>
        <a class="save-cart save-cart-img-section" [ngbPopover]="popSaveContent" [popoverTitle]="popSaveTitle"
          triggers="manual" #p2="ngbPopover" placement="top" (click)="toggle(p2)" container="body"
          popoverClass="popover-links saveorder-incart {{baseSiteId}}" *ngIf="!punchOutKey">
          <img src="../../assets/icons/{{baseSiteId}}/saved-orders-plus.png" alt="Save order" /><span>
            <!--{{'addToCartItems.saveOrder'|cxTranslate}}-->
            Add to my favorites
          </span></a>
        <ng-template #popTitle><span>
            <!-- {{'addToCartItems.clearTitle'|cxTranslate}}  -->
            Clear cart of all products?
          </span>
        </ng-template>

        <!-- <a class="clear-cart clear-cart-img-section" [ngbPopover]="popContent" [popoverTitle]="popTitle"
          triggers="manual" #p1="ngbPopover" placement="top" (click)="toggle(p1)" container="body"
          popoverClass="popover-links">
          <img src="../../assets/icons/trash.svg" alt="Delete" />
          <span>
           
            Clear cart
          </span></a> -->

        <a href="javascript:void(0)" target="" aria-label="download as" class="xls_cart xls-cart-img-section"
          id="tealium-xls" data-di-id="#tealium-xls" (click)="exportXls()">
          <img src="../../assets/icons/{{baseSiteId}}/excel_new.png" alt="" />
          <span>
            <!-- {{'addToCartItems.xls'|cxTranslate}}  -->
            XLS
          </span></a>
        <a href="javascript:void(0)" onclick="window.print();" target="" id="printLinkId" class="print-cart-img-section"
          data-di-id="#printLinkId">
          <img src="../../assets/icons/{{baseSiteId}}/print.svg" alt="" />
          <span>
            <!-- {{'addToCartItems.print'|cxTranslate}}  -->
            Print
          </span></a>
      </section>
    </section>
  </section>
</section>
<div *ngIf="deleteSuccess !== ''" class="global-alerts">
  <div class="alert alert-info alert-dismissable getAccAlert">
    <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
      data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    <span class="delete-succ" [innerHTML]="deleteSuccess"></span>{{ "addToCartItems.deleteSuccessMsg" | cxTranslate }}
  </div>
</div>
<div *ngIf="addSuccess" class="global-alerts">
  <div class="alert alert-info alert-dismissable getAccAlert">
    <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
      data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    {{ "addToCartItems.addProdSuccess" | cxTranslate }}
  </div>
</div>
<div *ngIf="orderBlock && showDangerAlert && productEntries?.length > 0" class="global-alerts">
  <div class="alert alert-danger alert-dismissable getAccAlert">
    <button (click)="closeDangerAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert"
      type="button" data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    {{ "addToCartItems.orderBlockMsg" | cxTranslate }}
  </div>
</div>
<section class="standart-cart" *ngIf="productEntries?.length > 0; else emptyCart">

  <div class="row whitebg">
    <div class="col-sm-4 mb-orderSubtotal">
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page" aria-label="subTotal">
        <section class="savings-total p-0 two" [ngClass]="isSticky === true ? 'header' : ''">

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
              <div class="orderTitleSticky">
                Order Total:
                <span *ngIf="headerLevelObj.length==0 && !updateTotal; else noPrice">
                  <!-- {{ getTotalPriceCalc(stdCartDetails) | currency : 'USD' : 'symbol' : '1.2-2' }} -->
                  <!-- {{standardCartDetails?.subTotal?.currencyIso}} -->

                  {{subTotalVal | currency : 'USD' : 'symbol' :
                  '1.2-2'}}

                </span><span *ngIf="headerLevelObj.length>0">$--</span>
                <!-- <ng-template #noPrice>
                  {{ "addToCartItems.noprice" | cxTranslate }}
                </ng-template> -->
              </div>
              <p class="fw-bold m-0 p-0 totalSaveMobile">Total Savings:&nbsp;<span class="greenfont"
                  *ngIf="headerLevelObj.length==0">{{totalSavings |
                  currency : 'USD' :
                  'symbol' : '1.2-2'}}</span>
                <span *ngIf="headerLevelObj.length>0">$--</span>
              </p>
            </div>
          </div>
          <button *ngIf="!updateTotal" type="button" class="btn-primary" (click)="openmodal(content)"
            [disabled]="continueDisableCheck()" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
            <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
            <!-- {{'addToCartItems.proceedToCheckout'|cxTranslate}} -->
            Continue
          </button>
          <button class="btn-secondary" (click)="updateCart()">
            <!-- {{'addToCartItems.updateOrder'|cxTranslate}} -->
            Edit Cart
          </button>
          <div class="row m-0 p-0">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="fw-bold m-0 p-0">By placing this order, you agree to the</div>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="fw-bold marginbot p-0"><a href="{{pdfUrl}}" target="_blank" class="fw-bold"
                  class="tncMobile">Terms & Conditions</a></div>
            </div>
          </div>
        </section>
        <section>
          <!-- <app-order-products></app-order-products> -->
        </section>
      </aside>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12 md-ipad-8">
      <div class="row whitebg" *ngIf="!punchoutCheckout">
        <section class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 bord-Right">
          <section class="row">
            <section class="col-md-12 select-Header-Section">
              <section class="select-Header">
                {{'selectVaccines.order_contract'|cxTranslate}}
              </section>
            </section>
            <!-- <section class="col-md-4 sort-by d-flex">
        <span class="mr-2 mt-1">Sort by:</span>
        <ng-select (change)="sortBy($event)" [items]="categoryList" bindLabel="name" bindValue="value"
        [multiple]="false" [(ngModel)]="selectedType">
        </ng-select>
        </section> -->
          </section>

          <!-- <section class="row"> -->
          <!-- <section class="col-md-12 select-Header-Section">
              <section class="select-Header-normal">
                Preferred contact method
              </section>
            </section> -->
          <!-- <section class="col-md-4 sort-by d-flex">
        <span class="mr-2 mt-1">Sort by:</span>
        <ng-select (change)="sortBy($event)" [items]="categoryList" bindLabel="name" bindValue="value"
        [multiple]="false" [(ngModel)]="selectedType">
        </ng-select>
        </section> -->
          <!-- </section> -->

          <div class="row marginleftCls">

            <div class="col-lg-7 col-md-7 col-sm-12 order2">
              <div class="row alignleftTopCls">
                <section class="col-12 ">
                  <section class="select-Header-normal">
                    Preferred contact method
                  </section>
                </section>
              </div>
              <div class="row alignleftTopCls">
                <!-- <div class="col-lg-6 col-md-6 col-sm-6">
                  <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation"
                    value="email" (click)="cMethodElection('email')" checked />
                </div> -->

                <div class="col-lg-6 col-md-6 col-sm-6">

                  <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation"
                    value="email" (click)="cMethodElection('email')" checked />

                  <label for="cntctPrefEml" class="Fields-label email-lable">

                    Email</label>

                </div>

              </div>
              <!-- <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label for="cntctPrefEml" class="Fields-label mt-0">
                    Email</label>
                </div>
              </div> -->

              <div class="row alignleftCls mb-1" *ngFor="let itm of emailArr; let emailIndex=index;">
                <div id="emailCheckout" class="col-lg-8 col-md-8 col-sm-8 spacebottomAddemail">

                  <ng-select [readonly]="" *ngIf="cMethodVal && baseSiteId=='vsh'" [searchable]="false"
                    [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select"
                    class="dropdown-credit" [(ngModel)]="itm.value" name="email_{{emailIndex}}"
                    (change)="addnewEmail($event,emailIndex,'cMethodVal')">

                    <ng-option value="" disabled>Select Email Address</ng-option>

                    <ng-option *ngFor="let email of contactDetails?.customerEmails" [value]="email"><span
                        [ngClass]="{'newEmaildrpdwncls': email == 'Add new email'}">{{email}}</span></ng-option>
                    <!-- <ng-option>Add new email</ng-option> -->
                    <!-- <ng-option *ngFor="let itm of dosesOfVaccines" [value]="itm">{{itm}}</ng-option> -->
                  </ng-select>



                  <ng-select [readonly]="" *ngIf="cMethodVal && baseSiteId!='vsh'" [searchable]="false"
                    [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select"
                    class="dropdown-credit" [(ngModel)]="itm.value" name="email_{{emailIndex}}"
                    (change)="addnewEmail($event,emailIndex,'cMethodVal')">

                    <ng-option value="" disabled>Select Email Address</ng-option>

                    <ng-option *ngFor="let email of contactDetails?.customerEmails" [value]="email"><span
                        [ngClass]="{'newEmaildrpdwncls1': email == 'Add new email'}">{{email}}</span></ng-option>
                    <!-- <ng-option>Add new email</ng-option> -->
                    <!-- <ng-option *ngFor="let itm of dosesOfVaccines" [value]="itm">{{itm}}</ng-option> -->
                  </ng-select>

                  <ng-select [readonly]="" [disabled] *ngIf="!cMethodVal" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="isocode" placeholder="Please select" class="dropdown-credit disabled"
                    [(ngModel)]="itm.value" name="email_{{emailIndex}}" (change)="addnewEmail($event,emailIndex,'')">

                    <ng-option value="" disabled>Select Email Address</ng-option>
                    <ng-option value="ns">Nothing Selected</ng-option>
                    <ng-option *ngFor="let email of contactDetails?.customerEmails" [value]="email">{{email}}</ng-option>
                    <ng-option value="-1">Add new email</ng-option>
                    <!-- <ng-option *ngFor="let itm of dosesOfVaccines" [value]="itm">{{itm}}</ng-option> -->
                  </ng-select>
                  <!-- {{itm.value}} -- {{itm.id}} -->
                </div>
                <div class="col-md-4 col-sm-4 spacebottomAddemail-right mt-3" *ngIf="emailIndex!=0">
                  <ng-template #popTitleDelete>
                    Delete this item from your cart?
                  </ng-template>
                  <ng-template #popContentDelete>
                    <button type="reset" class="
                    popover-close
                    btn
                    white-button
                    popover-cancel-button
                    cart-cancel
                  " data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
                      Cancel
                    </button>
                    <button class="
                    btn
                    blue-button
                    popover-cancel-button
                    cart-delete
                  " type="submit" data-di-id="di-id-3064f17d-e97cc628" (click)="
                    deleteEmail(itm)
                  ">
                      Delete
                    </button>
                  </ng-template>

                  <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual" #p1="ngbPopover"
                    placement="top" class="trash cart-edit-delete" (click)="deleteEmail(emailIndex)">
                    <img src="../../assets/icons/{{baseSiteId}}/trash.svg" alt="Delete" />

                    Delete
                  </a>
                </div>


                <div class="col-lg-8 col-md-8 col-sm-8 spacebottomAddemail" *ngIf="itm.id=='-1'">

                  <input type="text" class="formElement" style="width: 100%" name="newEmail_{{emailIndex}}"
                    id="newEmail_{{emailIndex}}" [(ngModel)]="itm.itemValue" (blur)="emailNullCheckValidation()">

                </div>
                <div class="errorlabel" *ngIf="itm.iserror">{{ErrMsg}}</div>

              </div>

              <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label class="ordrCntrctAddEmail greenbtm" *ngIf="!noshowaddemail" (click)="addemail()">Add
                    email</label>
                </div>
              </div>
              <ng-container *ngIf="showFax">
                <div class="row alignleftTopCls">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation"
                      (click)="cMethodElection('fax')" value="fax" />
                    <label for="cntctPrefEml" class="Fields-label fax-lable">
                      Fax</label>
                  </div>
                </div>
                <!-- <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label for="cntctPrefEml" class="Fields-label mt-0">
                    Fax</label>
                </div>
              </div> -->

                <div class="row alignleftCls">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    @if (contactDetails) {
                    <input #faxnumber *ngIf="cMethodVal" type="text" class="formElement" placeholder="XXX-XXX-XXXX"
                      appPhoneMask disabled id="faxcontactmethod" [(ngModel)]="contactDetails.contactFax">
                    <input #faxnumber *ngIf="!cMethodVal" type="text" class="formElement" maxlength="12"
                      (click)="updateValidity()" placeholder="XXX-XXX-XXXX" appPhoneMask id="faxcontactmethod"
                      (keyup)="validateFaxNumber(faxnumber.value,'fax',0)" [(ngModel)]="contactDetails.contactFax">
                    }
                  </div>
                </div>
                <span class="redmsg" *ngIf="!faxValid">Please enter fax number</span><br />
                <span class="redmsg" *ngIf="!faxErrorMsg">Invalid Fax Number</span>
              </ng-container>

              <div class="row alignleftTopCls" *ngIf="isAsmUser && contactDetails?.salesRepEmail">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label for="salesRepEmail" class="Fields-label mt-0">Email</label>
                </div>
              </div>
              <div class="row alignleftCls mb-2" *ngIf="isAsmUser && contactDetails?.salesRepEmail">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <input type="text" disabled class="formElement" id="salesRepEmail"
                    [(ngModel)]="contactDetails.salesRepEmail">
                </div>
              </div>

            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 order1">

              <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label for="cntctPrefEml" class="Fields-label mt-0">
                    Order Placed By</label>
                </div>
              </div>
              <div class="row alignleftCls">
                <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="!isAsmUser">
                  @if (contactDetails) {
                  <input #name type="text" class="formElement" id="orderBy" (keyup)="validateOrderByName(name.value)"
                    [(ngModel)]="contactDetails.contactName" required><br />
                  <span class="redmsg" *ngIf="orderByErrorMsg">Please enter name</span>
                  }
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isAsmUser">
                  <input #name type="text" class="formElement" id="orderByAsm" (keyup)="validateOrderByName(name.value)"
                    [(ngModel)]="contactDetails.asmContactName" required><br />
                  <span class="redmsg" *ngIf="orderByErrorMsg">Please enter name</span>
                </div>
              </div>
              <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label for="cntctPrefEml" class="Fields-label mt-0">
                    Phone</label>
                </div>
              </div>
              <div class="row alignleftCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  @if (contactDetails) {
                  <input #phonenumber type="text" maxlength="12" class="formElement" id="faxcontactmethod"
                    (keyup)="validateFaxNumber(phonenumber.value,'phone',0)"
                    [(ngModel)]="contactDetails.contactPhone"><br />
                  <span class="redmsg" *ngIf="!phoneErrorMsg">This field is required</span>
                  }
                </div>
              </div>

              <div id="registerBilling" class="row alignleftTopCls">
                <ng-template #errorPopContent>Add mobile number to receive shipping/delivery texts</ng-template>
                <div class="col-lg-12 col-md-12 col-sm-12">

                  <label for="cntctPrefEml" class="Fields-label mt-0">
                    Mobile <a placement="top" [ngbPopover]="errorPopContent"><img
                        src="../../../../assets/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg"
                        class="faq" /></a></label>

                </div>
              </div>
              <div class="row alignleftCls" *ngFor="let mobile of mobileList; let mobindex=index;">

                <div class="col-lg-8 col-md-8 col-sm-8 mb-1">
                  <input #mobilenumber type="text" class="formElement" placeholder="xxx-xxx-xxxx"
                    (keyup)="validateFaxNumber(mobile.value,'mobile',mobindex)" maxlength="12"
                    [(ngModel)]="mobile.value" id="faxcontactmethod_{{mobindex}}" name="faxcontactmethod_{{mobindex}}">
                  <span class="redmsg" *ngIf="mobile.iserror">Invalid Mobile Number</span>
                </div>
                <div class="col-md-4 col-sm-4 mobileTrash" *ngIf="mobindex!=0" style="margin-top:8px">
                  <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual" #p1="ngbPopover"
                    placement="top" class="trash cart-edit-delete" (click)="deleteMobile(mobindex)">

                    <img src="../../assets/icons/{{baseSiteId}}/trash.svg" alt="Delete" />

                    Delete

                  </a>
                </div>
              </div>

              <div class="row alignleftTopCls">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <label class="ordrCntrctAddEmail greenbtm" (click)="addMobile()" *ngIf="!noshowaddmobile">Add mobile
                    number</label>
                </div>
              </div>

            </div>
          </div>
          <!--fluProductsList - there is no such list declared. Not sure why this section is added-->
          <section class="row row-Gap" *ngFor="let user of fluProductsList; let i = index" id="{{user.code}}">
            <section class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 prod-Image-Section mt-3">
              <a (click)="productDetails(user)">
                <img *ngIf="user.thumbNailImg !== ''" src="{{baseUrl}}{{user.thumbNailImg}}" class="prod-Image"
                  title="{{user.name}}" alt="prodImg" />
                <img *ngIf="user.thumbNailImg == ''"
                  [src]="'../../assets/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" class="prod-Image"
                  title="{{user.name}}" alt="defImg" />
              </a>
            </section>
            <section class="col-10 col-sm-4 col-md-6 col-lg-6 col-xl-6 prod-Desc-Div mt-1">
              <section class="container">
                <section class="row">
                  <!-- <section class="col-md-12 col-lg-12 col-xl-12">
            <a (click)="productDetails(user)" title="{{user.name}}" class="prod-Name" [innerHTML]="user.baseProductName"></a>
          </section> -->
                  <a (click)="navigatePDP(user)" class="col-md-12 col-lg-12 col-xl-12 product-Desc-Section"
                    [innerHTML]="user.variantProductDescription">
                  </a>
                  <ng-template [ngIf]="user?.ageIndication">
                    <section class="col-md-12 col-lg-12 col-xl-12 age-indication mt-2">
                      <span>{{user?.ageIndication}}</span>
                    </section>
                  </ng-template>
                  <section class="col-md-12 col-lg-12 col-xl-12 prod-No mt-2">
                    <span class="prodct-No">{{user.code}}</span><span class="mr-1 ml-1">|</span>
                    <span>{{user.manufacturer}}</span>
                  </section>
                </section>
              </section>
            </section>
            <!-- ============================Price=========================================== -->
            <section class="col-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 i-Padding">
              <section class="container">
                <section class="row pdt-price">
                  <section class="col-md-12 col-lg-12 col-xl-12">
                    <span class="your-Price">{{'selectVaccines.yourPrice'|cxTranslate}}</span><br />
                    <span>$</span><br />
                    <a [ngbPopover]=viewSavings placement="top" #s3="ngbPopover" triggers="manual"
                      popoverClass="savedordermini-popover"
                      (click)="deletePopup(s3,item)">{{'selectVaccines.viewSaving'|cxTranslate}}</a><br />
                    <div class="mt-2">{{'selectVaccines.pricePrompt'|cxTranslate}}</div>
                    <span>$</span>
                    <ng-template #viewSavings>
                      <table class="view-savings w-100">
                        <tbody>
                          <tr>
                            <td>{{'selectVaccines.yourPrice'|cxTranslate}}</td>
                            <td>$--</td>
                          </tr>
                          <tr>
                            <td>{{'selectVaccines.directSaving'|cxTranslate}}</td>
                            <td>$--</td>
                          </tr>
                          <tr>
                            <td>{{'selectVaccines.onlineSavings'|cxTranslate}}<sup>2</sup></td>
                            <td>$--</td>
                          </tr>
                          <tr class="price-savings">
                            <td>{{'selectVaccines.yourPriceSavings'|cxTranslate}}</td>
                            <td>$--</td>
                          </tr>
                          <tr class="prompt-pay">
                            <td>{{'selectVaccines.promptPayDiscount'|cxTranslate}}<sup>3</sup></td>
                            <td>$--</td>
                          </tr>
                          <tr class="price-savings">
                            <td>{{'selectVaccines.yourPricePay'|cxTranslate}}</td>
                            <td>$--</td>
                          </tr>
                        </tbody>
                      </table>
                    </ng-template>
                  </section>
                  <!-- <section class="col-md-12 col-lg-12 col-xl-12">
            <span class="prod-Price">{{user?.price?.value}}</span>
          </section> -->
                  <section class="col-md-12 col-lg-12 col-xl-12 vol-Pricing"
                    *ngIf="!user?.discontinued && user?.available">
                    <a class="link vol-Price" placement="top" *ngIf="user?.volumePrices?.length > 0"
                      [ngbPopover]="popContent" popoverTitle="{{'selectVaccines.volumePrice'|cxTranslate}}">
                      {{'selectVaccines.volumePrice'|cxTranslate}}
                    </a>
                    <ng-template #popContent>
                      <table class="tb" id="vol-price-pdp" aria-describedby="volTable">
                        <thead>
                          <th scope="col"></th>
                        </thead>
                        <tbody *ngFor="let prices of user?.volumePrices; let i=index">
                          <tr>
                            <td>{{prices?.minQuantity}} - {{prices?.maxQuantity}}
                              {{'selectVaccines.units'|cxTranslate}}:
                            </td>
                            <td>{{prices?.value | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                            <td><span *ngIf="i>0" class="save-price">{{'selectVaccines.save'|cxTranslate}}
                                {{user?.volumePrices[0].value - user?.volumePrices[i].value | currency : 'USD' :
                                'symbol' : '1.2-2'}}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </ng-template>
                  </section>
                </section>
              </section>
            </section>
            <!-- ==============================units========================================== -->
            <section class="col-5 col-sm-5 col-md-2 col-xs-6 p0 pad-Port">
              <section class="container p0">
                <section class="units">
                  <div class="prodUnits">{{'selectVaccines.units'|cxTranslate}}</div>
                  <section class="unit-area">
                    <span class="disabled " aria-hidden="true" id="{{'minusIcon'+user?.code}}">
                      <img src="../../assets/icons/{{baseSiteId}}/less.svg" id="{{'unitMinus'+user?.code}}"
                        class="disabled-img" alt=""
                        (click)="performQuantityComputation(2,user?.code,user?.quantityPerUnit,user?.uom)">
                      <img src="../../assets/icons/{{baseSiteId}}/less-disable.svg"
                        id="{{'unitMinusDisable'+user?.code}}" alt="">
                    </span>
                    <input type="number" class="prod-quantity text-center" value="{{'0'}}"
                      onkeypress="return /[0-9a-zA-Z]/i.test(event.key)" (keydown)="validateInput($event)"
                      (keyup)="performQuantityComputation(null,user?.code,user?.quantityPerUnit,user?.uom)"
                      id="{{'prodQuantity'+user?.code}}" min="0" max="99999" appNoMouseScroll />
                    <span aria-hidden="true" id="{{'plusIcon'+user?.code}}">
                      <img src="../../assets/icons/{{baseSiteId}}/more.svg"
                        (click)="performQuantityComputation(1,user?.code,user?.quantityPerUnit,user?.uom)"
                        id="{{'unitPlus'+user?.code}}" alt="">
                      <img src="../../assets/icons/{{baseSiteId}}/more-disable.svg"
                        id="{{'unitPlusDisable'+user?.code}}" class="disabled-img" alt="">
                    </span>
                  </section>
                  <section class="doses-section" id="{{'noOfDoses'+user?.code}}">
                    {{'0' }} {{user?.uom}}
                  </section>
                  <span class="available-now" *ngIf="user?.orderable==true  && user?.soldOut==true">
                    {{user?.soldOutMessageCreate}}
                  </span>
                  <span class="available-order"
                    *ngIf="user?.orderable==true  && user?.soldOut==false && user?.shipNow=='ON' && user?.waitlist==false">
                    {{'selectVaccines.available'|cxTranslate}}
                  </span>
                  <span class="wait-list" *ngIf="user?.orderable==true && user?.soldout==false && user?.waitlist==true">
                    {{'selectVaccines.waitlist'|cxTranslate}}
                  </span>
                </section>

                <ng-template #NotAccept>
                  <section class="units-Non-Accepting">
                    <span *ngIf="!user.available && user.discontinued===false" class="Not-Available">
                      {{user?.availabilityText ? user?.availabilityText :
                      ('selectVaccines.product_unavailable'|cxTranslate)}}
                    </span>
                    <span class="" *ngIf="user.discontinued===true" class="Not-Available">
                      {{'selectVaccines.product_discontinued'|cxTranslate}}</span>
                  </section>
                </ng-template>

              </section>
            </section>
            <section class='col-md-12 col-lg-12 col-xl-12'
              *ngIf="fluProductsList.length>1 && i<fluProductsList.length-1">
              <hr>
            </section>
          </section>
        </section>
      </div>
      <div class="row whitebg bord-Right">
        <div class="col-12">
          <section class="
          col-12
          left-section
          float-left
          cart-left" [ngClass]="punchoutCheckout ? 'section-height-punchout' : 'section-height'">
            <section class="cart-accordion">
              <!-- accordion:start-->
              <div class="sanofi-accordion" *ngFor="let locSpecificCart of stdCartDetails; let i = index">
                <div class="panel-group">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <section class="first-level-acc ">
                        <section class="deli_loc clear_fix" *ngIf="deliveryPickup=='delivery'">
                          <section class="cart_shipto col-sm-6 col-md-6 col-lg-6 cart_shipto pl0">
                            <section class="firstLevel-acc cartShipToHeader ">
                              <section class="">
                                <section class="ship-address">
                                  <section id="location-select">
                                    <section class="location-icon">
                                      <span class="glyph-icon">
                                        <i class="fas fa-map-marker-alt icon mr-3"></i>
                                      </span>
                                    </section>
                                    <section class="location-Details">
                                      <span class="selected-loc">
                                        {{locSpecificCart.shipToLoc_name}}
                                        ({{locSpecificCart?.shipToLoc_id}})
                                      </span>
                                      <p class="ordercontctdetails">
                                        <!-- 7TH AND FORRESTER STS RM B24 BSMT<br />
    
                                        HARRISBURG, PA 17120-0001 -->
                                        {{locSpecificCart?.shipToParty?.shippingAddress?.formattedAddress}}
                                      </p>
                                      <!-- <span class="selected-loc">{{selectedData?.name}}
                                                 {{"("+selectedData?.uid+")"}} </span> -->
                                      <!--<span class="addr-label">
                                                 {{selectedData?.line1 ? selectedData?.line1+', ' : ''}}
                                                 {{selectedData?.line2 ? selectedData?.line2+', ' : ''}}
                                                 {{selectedData?.town ? selectedData?.town+', ' : ''}}
                                                 {{selectedData?.region?.isocodeShort ? selectedData?.region?.isocodeShort+' ' : ''}}
                                                 {{selectedData?.postalCode}}</span>
                                                 <div class="change-loc" role="button" *ngIf="changeLocation"
                                                 (click)="open(content)">{{'account.changeLocation'|
                                                 cxTranslate}}</div>-->
                                    </section>
                                    <!-- <section class="custome-modal">
                                              <ng-template #content let-modal>
                                                  <section class="modal-header cart-Modal-Header">
                                                      <button type="button" class="close" aria-label="Close"
                                                          (click)="modal.dismiss('Cross click')">
                                                          <img alt="" src="../../assets/icons/close.png">
                                                      </button>
                                                      <h4 class="modal-title" id="modal-basic-title">
                                                          {{'account.selectLocation'| cxTranslate}}</h4>
                                                  </section>
                                                  <section class="modal-body">
                                              
                                                      <section class="input-group loc-SearchBar">
                                                          <span class="input-group-btn">
                                                              <button class="btn" type="button">
                                                                  <span class="loc-Search-Icon">
                                                                  </span>
                                                              </button>
                                                              <input type="text" #clientName
                                                                  (keyup)="SearchClientName(clientName.value)"
                                                                  class="form-control searchboxnew"
                                                                  placeholder="{{'account.filterByLocation'| cxTranslate}}	" />
                                                          </span>
                                                      </section>
                                                      <hr
                                                          [ngClass]="{'displayNone':searchedClientList?.length===0}" />
                                                      <section>
                                                          <section
                                                              [ngClass]="{'displayNone':searchedClientList?.length===0}"
                                                              class="custom-control custom-radio radio_grp label-location w-100 m-0">
                                                              <table aria-describedby="shiptolocation"
                                                                  *ngFor="let data of searchedClientList;  let i = index"
                                                                  class="w-100">
                                                                  <tr class="sample-header">
                                                                      <th scope="col"></th>
                                                                      <th scope="col"></th>
                                                                  </tr>
                                                                  <tr class="line-location"
                                                                      [ngClass]="{'label-location': (i !== searchedClientList.length-1)}">
                                              
                                                                      <input type="radio"
                                                                          (change)='onOptionsSelected(data)'
                                                                          [id]="data?.id"
                                                                          [checked]="selectedData?.id == data?.id"
                                                                          name="customRadio"
                                                                          class="custom-control-input" />
                                                                      <label
                                                                          class="custom-control-label secloct w-100"
                                                                          [for]="data?.id">
                                                                          {{data?.companyName}}
                                                                          {{"("+data?.unitID+")"}}
                                                                      </label>
                                                                      <p class="labelpp"> {{data?.line1 ?
                                                                          data?.line1+', ' : ''}}
                                                                          {{data?.line2 ? data?.line2+', ' :
                                                                          ''}}
                                                                          {{data?.town ? data?.town+', ' :
                                                                          ''}}
                                                                          {{data?.region?.isocodeShort ?
                                                                          data?.region?.isocodeShort+' ' :
                                                                          ''}}
                                                                          {{data?.postalCode}}
                                                                      </p>
                                              
                                                                  </tr>
                                                              </table>
                                                          </section>
                                              
                                                      </section>
                                                  </section>
                                                  <section class="modal-footer">
                                                      <button type="button" class="btn location-done"
                                                          (click)='onSubmit()'
                                                          (click)="modal.close('Save click')">
                                                          {{'account.done'| cxTranslate}}
                                                      </button>
                                                  </section>
                                              </ng-template>
                                              </section> -->
                                  </section>
                                </section>
                              </section>
                            </section>
                          </section>
                          <section class=" col-sm-6 col-md-6 col-lg-6 float-right"
                            *ngIf="!locSpecificCart.futureShipAdded">
                            <div class="row">
                              <div class="col-sm-12 col-md-12 col-lg-12 alignRight">

                                <div class="row">
                                  <div class="col-md-6 col-sm-6 col-lg-6 m-0 p-0 mb-delivery delLabelMobile">
                                    <h6 class="fw-bold" style="float:right; margin-right:5px;">
                                      Requested delivery date
                                    </h6>
                                  </div>
                                  <div class="col-md-6 col-sm-6 col-lg-6 m-0 p-0 mb-delivery delDateMobile">
                                    <section class="control-group fw-normal">
                                      {{getRequestedDate(locSpecificCart.requestedDeliveryDate)}}
                                      <!-- <p class="mx0 mb1 cal-content">
                                      The requested Date is not a guarantee and may change based
                                      on product availability and unforeseen delays
                                    </p> -->
                                    </section>
                                  </div>
                                </div>


                                <!-- <section class="delivery-content multipleLocDelivery">
                                  <section class="delivary-details cart-delivery-date">
                                    
                                    <section class="calender">
                                      <section class="form-horizontal mb0">
                                        
                                      </section>
                                    </section>
                                  </section>
                                </section> -->
                              </div>
                            </div>

                          </section>
                        </section>
                        <section class="ship_addr clear_fix" *ngIf="deliveryPickup=='pickup'">
                          <section class="col-sm-4 col-md-4 col-lg-4 cart_shipto pl0 float-left">
                            <h6>{{'addToCartItems.pickLocation'|cxTranslate}}</h6>
                            <p>
                              {{'addToCartItems.sanofiName'|cxTranslate}}<br>{{'addToCartItems.locationLine1'|cxTranslate}}<br>{{'addToCartItems.locationLine2'|cxTranslate}}
                            </p>
                          </section>
                          <section class=" col-sm-6 col-md-6 col-lg-6 px0 float-left" [hidden]="getExpandedItems(i)">
                            <section class="delivery-content">
                              <section class="delivary-details cart-pickup-date">
                                <h6 class="requested-date"> {{'addToCartItems.pickupDate'|cxTranslate}}</h6>
                                <section class="calender">
                                  <section class="form-horizontal mb0">
                                    <section class="control-group float-left">
                                      <section class="controls input-append date cart-delivery-date-picker" data-date=""
                                        data-date-format="mm/dd/yyyy" data-link-field="dtp_input2"
                                        data-link-format="mm/dd/yyyy">
                                        <span class="add-on"><i class="icon-th"></i>
                                        </span>
                                        <input type="text" placeholder="DD/MM/YYYY" class="delivery-pickup-calendar"
                                          bsDatepicker [(ngModel)]="pickupDate" [minDate]="minPickupDate"
                                          [daysDisabled]="[0,6]" [maxDate]="maxPickupDate"
                                          (bsValueChange)="onPickupDateChange($event)"
                                          [bsConfig]="{ containerClass: 'theme-green deliveryPickup' }">
                                      </section>
                                    </section>
                                    <ng-select [items]="timeFormat" bindLabel="name" bindValue="selectedTime"
                                      [multiple]="false" name="selectedTime" placeholder="Set Time"
                                      [(ngModel)]="selectedTime" [searchable]="false">
                                    </ng-select>
                                  </section>
                                </section>
                              </section>
                              <p class="pickupTextMsg">
                                {{'addToCartItems.pickupMsg'|cxTranslate}}
                                <br>{{'addToCartItems.customerService'|cxTranslate}}
                                {{'addToCartItems.customerServiceNo'|cxTranslate}}
                              </p>
                            </section>
                          </section>
                        </section>
                        <span class="accMinusIcon fa-minus acc-plus-icon fa plusMinusIcon"
                          [hidden]="getExpandedItems(i)" (click)="toggleAccordion(i)">
                        </span>
                        <span class="accPlusIcon fa-plus acc-plus-icon fa plusMinusIcon" [hidden]="!getExpandedItems(i)"
                          (click)="toggleAccordion(i)">
                        </span>
                      </section>
                    </div>
                    <div id="pdp-list2" class="panel-collapse">
                      <div class="panel-body">
                        <!-- <section class="pdp-list-data pdp-list-data-section">
                         
                        </section> -->
                      </div>
                    </div>
                  </div>
                </div>
                <section [hidden]="getExpandedItems(i)" class="row col-sm-12 pdp-list-data" style="margin-left:0%;">
                  <section class="col-lg-1 col-md-1 displayNoneForDevice">&nbsp;</section>
                  <section class="col-lg-5 col-md-5 col-sm-12 mb-pl-10 purchase-order" *ngIf="!punchOutKey">
                    <div class="row col-sm-12">
                      <div class="col-md-12 marginbtm">

                        <!--bnot sure why beow logic added based on 1st product and that too on shipNow flag.
                        ideally should be based on flu flag-->
                        <span class="fw-bold" *ngIf="locSpecificCart.entries[0]?.product?.shipNow!='ON'">Purchase order
                          #<br />
                          <span *ngIf="!locSpecificCart?.poMandatory" class="fw-normal">(Optional)</span></span>
                        <span class="fw-bold" *ngIf="locSpecificCart.entries[0]?.product?.shipNow=='ON'">Influenza
                          Vaccine
                          PO #<br />
                          <span *ngIf="!locSpecificCart?.poMandatory" class="fw-normal">(Optional)</span></span>

                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 marginbtm">
                        <input type="text" class="formElement ponum" maxlength="35" appPhoneMask
                          [(ngModel)]="locSpecificCart.POnumber" name="po_{{i}}" id="po_{{i}}"
                          (keyup)="poCheck(locSpecificCart)"
                          [ngClass]="locSpecificCart?.poMandatory && locSpecificCart?.poError && locSpecificCart?.POnumber?.trim()?.length==0 ? 'red-border' : 'normal-border'">
                      </div>
                      <div class="defaulterrormsg ml-4 pb-1"
                        *ngIf="locSpecificCart?.poMandatory && locSpecificCart?.poError && locSpecificCart?.POnumber?.trim()?.length==0">
                        This field is required by your organization.
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 marginbtm">
                        <span class="fw-bold">Attention<span class="fw-normal">(Optional)</span></span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 marginbtm">

                        <input type="text" class="formElement" maxlength="35" name="atten_{{i}}"
                          [(ngModel)]="locSpecificCart.attention" placeholder="John Smith"
                          onkeypress="return /[a-z 0-9]/i.test(event.key)" id="atten_{{i}}">
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-md-12 marginbtm">
                        <span class="dateshowBold fw-bold-small">Special Instructions<span
                            class="fw-normal">(Optional)</span></span>
                      </div>
                    </div> -->
                    <!-- <div class="row">
                      <div class="col-md-12 marginbtm"><input type="text" class="formElement" appPhoneMask
                          id="faxcontactmethod" [(ngModel)]="productentry.instruction" style="height: 78px !important;">
                      </div>
                    </div> -->
                  </section>
                  <section class="col-lg-5 col-md-6 col-sm-12 mb-pl-10 mb-pt-10">


                    <table class="alignRight mb-location">
                      <tr>
                        <td class="ff-bold">Location subtotal</td>
                        <td class="fw-normal" style="text-align:right;">
                          <!-- {{locSpecificCart.totalPrice.value}}/{{locSpecificCart.totalExciseTax.value}}/{{locSpecificCart.quantity}}
                          -- {{locSpecificCart.totalTax.value}} -->
                          <!-- <span *ngIf="!headerLevelObj.hidePriceForTotals">{{locSpecificCart.ProductSummedPrice |
                            currency : 'USD' : 'symbol' : '1.2-2'}}</span> -->

                          <span
                            *ngIf="headerLevelObj.length==0">{{locSpecificCart.subTotal.value+locSpecificCart.totalExciseTax.value
                            |
                            currency : 'USD' : 'symbol' : '1.2-2'}}</span>


                          <span *ngIf="headerLevelObj.length>0">$--</span>
                        </td>
                      </tr>
                      <ng-container *ngIf="salesTaxFlag=='y';else salesTaxNotMandatory">
                        <tr>
                          <td class="ff-bold">Sales tax
                          </td>
                          <td class="fw-normal" style="text-align:right;">

                            <span *ngIf="headerLevelObj.length==0">{{locSpecificCart?.totalSalesTaxPrice?.value |
                              currency :
                              'USD' : 'symbol' : '1.2-2'}}</span>
                            <span *ngIf="headerLevelObj.length>0">$--</span>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #salesTaxNotMandatory>
                        <tr *ngIf="locSpecificCart?.totalSalesTaxPrice && locSpecificCart?.totalSalesTaxPrice?.value>0">
                          <td class="ff-bold">Sales tax
                          </td>
                          <td class="fw-normal" style="text-align:right;">

                            <span *ngIf="headerLevelObj.length==0">{{locSpecificCart?.totalSalesTaxPrice?.value |
                              currency :
                              'USD' : 'symbol' : '1.2-2'}}</span>
                            <span *ngIf="headerLevelObj.length>0">$--</span>
                          </td>
                        </tr>
                      </ng-template>
                      <tr *ngIf="locSpecificCart.totalWebDiscount.value!=0">
                        <td class="ff-bold vshSave">{{baseSiteId=="vsh"?"VaccineShop Savings":"VaxServe.com Savings"}}
                        </td>
                        <td class="greenfont" style="text-align:right;">
                          <span *ngIf="headerLevelObj.length==0">{{locSpecificCart.totalWebDiscount.value |
                            currency :
                            'USD' : 'symbol' : '1.2-2'}}</span>
                          <span *ngIf="headerLevelObj.length>0">$--</span>
                        </td>
                      </tr>
                      <ng-container *ngIf="otherDiscountsFlag=='y';else otherDiscNotMandatory">
                        <tr>
                          <td class="ff-bold vshSave">Other discounts
                          </td>
                          <td class="greenfont" style="text-align:right;">{{locSpecificCart?.totalOtherDiscount?.value |
                            currency : 'USD' : 'symbol' : '1.2-2'}}
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #otherDiscNotMandatory>
                        <tr
                          *ngIf="locSpecificCart?.totalOtherDiscount && locSpecificCart?.totalOtherDiscount?.value!=0">
                          <td class="ff-bold vshSave">Other discounts
                          </td>
                          <td class="greenfont" style="text-align:right;">{{locSpecificCart?.totalOtherDiscount?.value |
                            currency :
                            'USD' : 'symbol' : '1.2-2'}}
                          </td>
                        </tr>
                      </ng-template>
                      <tr>
                        <td class="ff-bold-grey">Location total</td>
                        <td class="ff-bold-grey" style="text-align:right;">
                          <span *ngIf="headerLevelObj.length==0"> {{locSpecificCart.totalPrice.value |
                            currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                          <span *ngIf="headerLevelObj.length>0">$--</span>
                        </td>
                      </tr>
                    </table>



                  </section>




                  <div class="col-12">
                    <section class="row">
                      <div class="col-md-12">
                        <div class="panel-body">
                          <section class="pdp-list-data"
                            *ngFor="let productentry of locSpecificCart?.entries; let j = index">
                            <section class="row row-20 pdp-list-product-data shiftRight">

                              <div class="col-md-1 img-left">
                                <section class="col-xs-12 col-sm-7 col-md-7 col-lg-7 pr0 cart_print">
                                  <a (click)="productDetails(productentry,i)">
                                    <img class="image-product"
                                      src="{{getImage(productentry.product?.images,'thumbnail')}}" alt="Product Img">

                                  </a>
                                </section>
                              </div>
                              <div class="col-md-10 cart_print marginleftCls img-right">
                                <h2 class="prod-title prodDes" [innerHTML]="productentry?.product?.baseProductName"
                                  (click)="productDetails(productentry,i)"></h2>
                                <section class="checkout-data">
                                  <p [innerHTML]="productentry?.product?.baseProductDescription" class="productCodeLink"
                                    (click)="productDetails(productentry,i)"></p>
                                  <p [innerHTML]="stdFluDesc(productentry)" class="productCodeLink"
                                    (click)="productDetails(productentry,i)"></p>
                                  <p class="ndcCode" *ngIf="productentry.product?.ndcCode">
                                    {{productentry.product?.ndcCode}}</p>
                                  <div>
                                    <p class="card-text">
                                      <!-- <span class="num-bold">{{itm?.description}}</span><br /> -->
                                      <span><strong>{{productentry?.product?.code}}</strong> |
                                        {{productentry?.product?.manufacturer}}</span>
                                      <span *ngIf="productentry?.contractName"
                                        [ngStyle]="{ 'margin-left': '10px'}"><strong>Contract Group:</strong>
                                        {{productentry?.contractName}}</span>
                                    </p>
                                  </div>
                                  <p class="inner-text"
                                    *ngIf="productentry.product?.innerText && productentry.product?.innerText !== ''">
                                    <span [innerHtml]="productentry?.product?.innerText"></span>
                                  </p>
                                </section>
                              </div>



                            </section>
                            <section class="row marginleftCls">

                              <section class="col-sm-12 col-md-12 col-lg-12 data-pad">
                                <table id="example1" style="width: 100%;"
                                  class="display account_invoice_financials dataTable no-footer">
                                  <thead>
                                    <tr class="heading">
                                      <th id="table1col1" class="date-new no-sort">Status</th>
                                      <th id="table1col2" class="date-new no-sort">Total Units</th>
                                      <th id="table1col3" class="invoice no-sort">Units in shipment</th>
                                      <th id="table1col4" class="po no-sort">Ship date</th>
                                      <th id="table1col5" class="invoice-amount no-sort right">Unit Price</th>
                                      <th id="table1col6" class="discount no-sort right">Unit Excise Tax</th>
                                      <th id="table1col7" class="no-sort right">Subtotal</th>
                                    </tr>
                                  </thead>
                                  <tbody class="datatable-row"
                                    *ngIf="(!productentry.futureShipExpProd || (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length==0 ))">
                                    <tr class="odd dateshow">
                                      <td rowspan="2" headers="table1col1">Open</td>
                                      <td>{{productentry?.quantity}}</td>
                                      <td>{{productentry?.quantity}}</td>
                                      <td>
                                        <!-- {{isFutershipAdded==false?getRequestedDate(locSpecificCart.requestedDeliveryDate):getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated) -->
                                        {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                      </td>
                                      <td class="right">
                                        <span
                                          *ngIf="!productentry?.product?.hidePriceForProduct">{{productentry?.basePrice?.value
                                          | currency : 'USD' :
                                          'symbol' : '1.2-2'}}</span>
                                        <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                      </td>
                                      <td class="right"><span
                                          *ngIf="!productentry?.product?.hidePriceForProduct">{{productentry.exciseTax.value
                                          | currency : 'USD' :
                                          'symbol' : '1.2-2'}}</span>
                                        <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                      </td>
                                      <td class="right">
                                        <span
                                          *ngIf="!productentry?.product?.hidePriceForProduct">{{(productentry?.basePrice?.value+productentry.exciseTax.value)*productentry?.quantity
                                          | currency : 'USD' :
                                          'symbol' : '1.2-2'}}</span>
                                        <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody class="datatable-row"
                                    *ngIf="productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length>0">

                                    <tr class="odd dateshow"
                                      *ngFor="let item of productentry.splitEntriesDeliveryDates;let i=index">

                                      <td *ngIf="i==0" [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                        headers="table1col1">{{i==0?'Open':' '}}</td>
                                      <td *ngIf="i>0"></td>
                                      <!-- <td rowspan="2" headers="table1col1" *ngIf="i>0"></td> -->

                                      <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>

                                      <!-- <td *ngIf="i>0"></td> -->

                                      <!-- <td style="white-space: pre-line">

                                        {{i==0?item.splitQuantity:("Week of" +'\n'+(item.splitdeliveryDate|

                                        date:'MM/dd/yyyy'))}}

                                      </td> -->
                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                      </td>

                                      <!-- <td style="white-space: pre-line">{{i==0?("Week of" +'\n'+(item.splitdeliveryDate|

                                        date:'MM/dd/yyyy')):''}}

                                      </td> -->
                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>

                                      <td class="right">

                                        {{i==0?'$'+productentry?.basePrice?.value:''}}

                                      </td>

                                      <td class="right">{{i==0?(productentry.sim_excise_tax.value | currency : 'USD' :
                                        'symbol' : '1.2-2'):''}}</td>

                                      <td class="right">

                                        {{i==0?(((productentry?.basePrice?.value+productentry.sim_excise_tax.value)*productentry.quantity)|
                                        currency : 'USD' :
                                        'symbol' : '1.2-2'):''}}

                                      </td>

                                    </tr>

                                  </tbody>
                                </table>
                                <table id="mb-example1" style="width: 100%;"
                                  class="display account_invoice_financials dataTable no-footer">

                                  <tbody class="datatable-row"
                                    *ngIf="(!productentry.futureShipExpProd || (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length==0 ))">
                                    <tr class="odd dateshow">
                                      <td class="left-td">Status</td>
                                      <td>Open</td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Total Units</td>
                                      <td>{{productentry?.quantity}}</td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Units in shipment</td>
                                      <td>{{productentry?.quantity}}</td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Ship date</td>
                                      <!-- <td>{{getRequestedDate(locSpecificCart.requestedDeliveryDate)}}<br>(Estimated)
                                      </td> -->
                                      <td>
                                        <!-- {{isFutershipAdded==false?getRequestedDate(locSpecificCart.requestedDeliveryDate):getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated) -->
                                        {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                      </td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Unit Price</td>
                                      <td class="right">{{productentry.totalPrice.value/productentry.quantity | currency
                                        : 'USD' :
                                        'symbol' : '1.2-2'}}
                                      </td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Unit Excise Tax</td>
                                      <td class="right">{{productentry.sim_excise_tax.value | currency : 'USD' :
                                        'symbol' : '1.2-2'}}</td>
                                    </tr>
                                    <tr class="odd dateshow">
                                      <td class="left-td">Subtotal</td>
                                      <td class="right">
                                        {{((productentry.totalPrice.value+productentry.sim_excise_tax.value)*productentry.quantity)
                                        | currency : 'USD' :
                                        'symbol' : '1.2-2'}}
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody class="datatable-row"
                                    *ngIf="productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length>0">

                                    <tr class="odd dateshow"
                                      *ngFor="let item of productentry.splitEntriesDeliveryDates;let i=index">

                                      <td rowspan="2" headers="table1col1">{{i==0?'Open':' '}}</td>

                                      <!-- <td rowspan="2" headers="table1col1" *ngIf="i>0"></td> -->

                                      <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>

                                      <!-- <td *ngIf="i>0"></td> -->

                                      <!-- <td style="white-space: pre-line">

                                        {{i==0?item.splitQuantity:("Week of" +'\n'+(item.splitdeliveryDate|

                                        date:'MM/dd/yyyy'))}}

                                      </td> -->

                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                      </td>

                                      <!-- <td style="white-space: pre-line">{{i==0?("Week of" +'\n'+(item.splitdeliveryDate|

                                        date:'MM/dd/yyyy')):''}}

                                      </td> -->
                                      <td style="white-space: pre-line"
                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>

                                      <td class="right">

                                        {{i==0?'$'+productentry?.basePrice?.value:''}}

                                      </td>

                                      <td class="right">{{i==0?(productentry.sim_excise_tax.value|currency:'USD'
                                        :'symbol' : '1.2-2'):''}}</td>

                                      <td class="right">

                                        {{i==0?((productentry?.basePrice?.value+productentry.sim_excise_tax.value)*productentry.quantity|currency:'USD'
                                        :'symbol' : '1.2-2'):''}}

                                      </td>

                                    </tr>

                                  </tbody>
                                </table>
                              </section>
                              <!-- <section class="col-sm-3 col-lg-3 col-md-2 price-list">
                                <section class="product-price">
                                  <h6>
                                    {{'plp.yourPrice'|cxTranslate}}
                                  </h6>
                                  <span>{{productentry?.totalPrice?.value | currency}}
                                    {{productentry?.totalPrice?.currencyIso}}
                                  </span><br>
                                  <span class="priceTaxBlock" *ngIf="productentry?.sim_excise_tax.value > 0.00">
                                    {{productentry?.sim_excise_tax.value | currency}}
                                    {{productentry?.sim_excise_tax?.currencyIso}}/ {{productentry?.product?.unit}} federal
                                    excise tax will be added.
                                  </span>
                                </section>
                              </section> -->

                              <!-- <section class="col-lg-2 col-md-2 col-sm-2 hidden-xs
                                   delete-popover-container-rwd min-col-width pr0 width13 no-print">
                                <ng-template #popTitleDelete1>
                                  Delete this item from your cart?
                                </ng-template>
                                <ng-template #popContentDelete1>
                                  <button type="reset" class="popover-close btn white-button popover-cancel-button"
                                    data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
                                    Cancel
                                  </button>
                                  <button class="btn blue-button popover-cancel-button" type="submit"
                                    data-di-id="di-id-3064f17d-e97cc628"
                                    (click)="deleteCart(productentry?.entryNumber,productentry?.product?.name,i)">
                                    Delete
                                  </button>
                                </ng-template>
                                <a [ngbPopover]="popContentDelete1" [popoverTitle]="popTitleDelete1" triggers="manual"
                                  #p10="ngbPopover" placement="top" class="trash cart-edit-delete" (click)="openPopover(p10)">
                                  <img src="../../assets/icons/trash.svg" alt="Delete">
                                  Delete
                                </a>
                              </section> -->
                            </section>
                          </section>
                        </div>
                      </div>
                    </section>
                  </div>



                </section>

              </div>
              <!-- accordion: end-->
            </section>
          </section>
        </div>

      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 md-ipad-4">
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page dst-orderSubtotal" aria-label="subTotal">
        <section class="savings-total p-0 two" [ngClass]="isSticky === true ? 'header' : ''">

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
              <div class="orderTitleSticky">
                Order Total:
                <span *ngIf="headerLevelObj.length==0 && !updateTotal; else noPrice">
                  <!-- {{ getTotalPriceCalc(stdCartDetails) | currency : 'USD' : 'symbol' : '1.2-2' }} -->
                  <!-- {{standardCartDetails?.subTotal?.currencyIso}} -->

                  {{subTotalVal | currency : 'USD' : 'symbol' : '1.2-2'}}
                </span>
                <span *ngIf="headerLevelObj.length>0">$--</span>
                <!-- <ng-template #noPrice>
                  {{ "addToCartItems.noprice" | cxTranslate }}
                </ng-template> -->
              </div>
              <p class="fw-bold m-0 p-0">Total Savings:&nbsp;<span class="greenfont"
                  *ngIf="headerLevelObj.length==0">{{totalSavings | currency : 'USD' :
                  'symbol' : '1.2-2'}}</span>
                <span *ngIf="headerLevelObj.length>0">$--</span>
              </p>
            </div>
          </div>
          <button *ngIf="!updateTotal" type="button" class="btn-primary" (click)="openmodal(content)"
            [disabled]="continueDisableCheck()" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
            <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
            <!-- {{'addToCartItems.proceedToCheckout'|cxTranslate}} -->
            Continue
          </button>
          <button class="btn-secondary" (click)="updateCart()">
            <!-- {{'addToCartItems.updateOrder'|cxTranslate}} -->
            Edit Cart
          </button>
          <div class="row m-0 p-0">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="fw-bold m-0 p-0">By placing this order, you agree to the</div>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="fw-bold marginbot p-0"><a href="{{pdfUrl}}" target="_blank" class="fw-bold greenbtm">Terms &
                  Conditions</a></div>
            </div>
          </div>
        </section>
        <section>
          <!-- <app-order-products></app-order-products> -->
        </section>
      </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page" aria-label="subTotal">
        <app-payment-method *ngIf="!punchoutCheckout" [stdCartType]="true"
          (selectedPaymentMethodEvent)="selectedPaymentMethodDetailsMethod($event)" [stdCheckoutFlow]=true
          (selectedCardOAcctDetailsEvent)="selectedCardOrAccountDetailsMethod($event)"></app-payment-method>
        <div class="row" *ngIf="!punchoutCheckout">
          <div class="col-md-12 col-sm-12">
            <h2 class="orderContact">
              Order contact</h2>
          </div>
        </div>
        <div class="row billing-address" *ngIf="!punchoutCheckout">
          <div class="col-md-6 col-sm-6 mobileWidth">
            <h3 class="productCode">Billing Address</h3>



            <p class="dataforaddblock">{{orderContactDetails?.accountNumber}}<br />
              <!-- <span
                *ngIf="orderContactDetails?.facilityName">{{orderContactDetails?.facilityName}}&nbsp;{{orderContactDetails?.facilityName2}}<br /></span> -->
              <span *ngIf="orderContactDetails?.companyName">{{orderContactDetails?.companyName}}<br /></span>
              <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->

              {{orderContactDetails?.formattedAddress}}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 mobileWidth">
            <h3 class="productCode">Payer address</h3>
            <p class="dataforaddblock">{{payerAddress?.accountNumber}}<br />
              <!-- <span
                *ngIf="payerAddress?.facilityName">{{payerAddress?.facilityName}}&nbsp;{{payerAddress?.facilityName2}}<br /></span> -->
              <span *ngIf="payerAddress?.companyName">{{payerAddress?.companyName}}<br /></span>
              <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->
              {{payerAddress?.formattedAddress}}
            </p>
          </div>
        </div>
      </aside>
    </div>
  </div>


</section>
<ng-template #emptyCart>
  <app-empty-cart compName="EmptyCartParagraphComponent"></app-empty-cart>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">

    <h3 class="modal-title modalTitle">Ready to place your order?</h3>
    <!-- <button class="btn-close" (click)="modal.dismiss()"></button> -->
  </div>
  <div class="modal-body">

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Order total</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-centr-amount marginleftCls">
          <!-- {{ getTotalPriceCalc(stdCartDetails) | currency : 'USD' :
          'symbol' : '1.2-2' }} -->
          <span *ngIf="headerLevelObj.length==0">{{subTotalVal | currency : 'USD' : 'symbol' :
            '1.2-2'}}</span>

          <span *ngIf="headerLevelObj.length>0">$--</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="no-sort-center marginleftCls p-0">Total with Prompt Pay:
          <!-- <span class="greenfont"> {{getTotalPriceCalc(stdCartDetails) +
            finalSaving | currency : 'USD' : 'symbol' : '1.2-2'}}</span> -->
          <span class="greenfont" *ngIf="headerLevelObj.length==0"> {{totalWithPromtPayDiscountSum | currency : 'USD' :
            'symbol' : '1.2-2'}}</span> <span *ngIf="headerLevelObj.length>0">$--</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Ship to locations</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div *ngFor="let itm of stdCartDetails; let i = index">
          <div class="fw-normal-center marginleftCls p-0">
            {{itm?.shipToLoc_name}}({{itm?.shipToLoc_id}})</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>


    <div class="row" *ngIf="!punchoutCheckout">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
      </div>
    </div>
    <div class="row" *ngIf="!punchoutCheckout">
      <div class="col-md-6 col-sm-6 col-lg-6" *ngIf="!isAsmUser">
        <div class="fw-normal-center marginleftCls p-0">{{contactDetails.contactName}}</div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-6" *ngIf="isAsmUser">
        <div class="fw-normal-center marginleftCls p-0">{{contactDetails.asmContactName}}</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-normal-center marginleftCls p-0" [innerHTML]="paymentMethod">
        </div>
      </div>
    </div>

    <div class="row" *ngIf="!punchoutCheckout">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-lg-9 col-sm-9 col-md-9" *ngIf="!punchoutCheckout">
        <button *ngIf="!updateTotal" type="button" class="btn-primary mt2 placeOrderBtn" (click)="proceedtoFinal()"
          [disabled]="orderBlock || checkoutClicked || yfEntry" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
          <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
          Yes, place order
        </button>
        <button class="btn-secondary mt2 EditOrderBtn" (click)="modal.dismiss()">
          Edit Order
        </button>
      </div>
      <div class="col-lg-9 col-sm-9 col-md-9" *ngIf="punchoutCheckout">
        <button *ngIf="!updateTotal" type="button" class="btn-primary mt2 placeOrderBtn" (click)="punchoutCheck()"
          [disabled]="orderBlock || checkoutClicked || yfEntry" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
          <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
          Transfer order
        </button>
        <button class="btn-secondary mt2 EditOrderBtn" (click)="modal.dismiss();redirectToCart()">
          Edit Cart
        </button>
      </div>
    </div>

  </div>
  <!-- <div class=" modal-footer">
          <button class="btn" ngbAutofocus (click)="modal.dismiss()">Done</button>
      </div> -->
</ng-template>

<!-- <form id="cxml_form" method="POST" [attr.action]="buyer_form_post_url" enctype="application/x-www-form-urlencoded"
  target="_blank">
  <input type="hidden" name="cXML-urlencoded" [attr.value]="xml">
</form> -->
<!-- <script type="text/javascript">document.getElementById('cxml_form').submit()</script> -->